import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Sidebar from '../../components/SidebarSociete';
import { Outlet, useNavigate } from 'react-router-dom';
import Logo from '../../Image/logo.png';
import { useDispatch } from 'react-redux';
import { suprimerSociete } from '../../Redux/actions/actionSociete';
import './css/societe.css';

const Societe = () => {
  const [show, setShow] = useState(false);

  let navigate = useNavigate();
  let dispatch = useDispatch();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const handleLogout = () => {
    localStorage.clear();
    dispatch(suprimerSociete());
    navigate('/adminSociete');
  }
  return (
    <div className='societe'>
      <div className='main'>
        <div className='sidebar_full'>
          <Sidebar hide={handleClose} logout={handleLogout} />
        </div>
        <div className='bloc_societe'>
          <div className='nav fixed-top nav_dashboard'>
            <div className='w-100 d-flex justify-content-between'>
              <div className='left'>
                <i className='fa fa-navicon' onClick={handleShow}></i>
                <div className='logo'>
                  <img src={Logo} alt='logo e-kaly' width="80px" title="logo e-kaly" />
                </div>
              </div>
              <div className="right">
                <div className='deconnect' onClick={handleLogout}>
                  <span>Se déconnecter</span>
                </div>
              </div>
            </div>
          </div>
          <Outlet />
        </div>
        <div className='content_offcanvas'>
          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Body>
              <div className='sidebar_mobileSociete'>
                <Sidebar hide={handleClose} logout={handleLogout}  />
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </div>
  )
}

export default Societe